module.exports = __webpack_public_path__ + "img/stickers-portfolio3.06caa93e.png";